export const QuestionCircleIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      opacity="0.3"
      d="M9.99982 18.3346C14.6022 18.3346 18.3331 14.6037 18.3331 10.0013C18.3331 5.39893 14.6022 1.66797 9.99982 1.66797C5.39746 1.66797 1.6665 5.39893 1.6665 10.0013C1.6665 14.6037 5.39746 18.3346 9.99982 18.3346Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99994 13.3319C10.4602 13.3319 10.8333 13.705 10.8333 14.1653C10.8333 14.6255 10.4602 14.9986 9.99994 14.9986C9.53971 14.9986 9.16661 14.6255 9.16661 14.1653C9.16661 13.705 9.53971 13.3319 9.99994 13.3319ZM8.82578 12.3886V11.0061H9.87578C11.2058 11.0061 12.1683 9.99109 12.1683 8.66109C12.1683 7.33109 11.2058 6.31609 9.87578 6.31609C8.52828 6.31609 7.60078 7.33109 7.60078 8.66109H6.11328C6.11328 6.56109 7.75828 4.93359 9.87578 4.93359C11.9933 4.93359 13.6558 6.56109 13.6558 8.66109C13.6558 10.7611 11.9933 12.3886 9.87578 12.3886H8.82578Z"
      fill="currentColor"
    />
  </svg>
);
